const locale = {
  locale: 'zh-CN',
  'global.selectholder': '请选择',
  'global.placeholder': '请输入...',
  'global.cancel': '取消',
  'global.confirm': '确定'
}

export default locale
